module.exports = __webpack_public_path__ + "img/acceleration.c45f4ed7.svg";